import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterLink } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { Subscription } from 'rxjs';
import { TranslatePipe } from '../../i18n/translate.pipe';
import { ConsentService } from '../../services/consent.service';

/**
 * Baner zgody na ciasteczka Google (Consent Mode v2). Wisi nad całą aplikacją -
 * osadzony raz w `app.component.html`, poza przełącznikiem układów, żeby był
 * widoczny również na stronach logowania i stronach prawnych.
 *
 * Pierwsza wizyta pokazuje trzy przyciski (wszystko / tylko niezbędne /
 * ustawienia); „Ustawienia prywatności" w stopce otwiera od razu listę
 * przełączników z aktualnym wyborem.
 */
@Component({
    selector: 'app-cookie-consent',
    templateUrl: './cookie-consent.component.html',
    styleUrls: ['./cookie-consent.component.css'],
    standalone: true,
    imports: [FormsModule, RouterLink, MatButtonModule, MatCheckboxModule, TranslatePipe]
})
export class CookieConsentComponent implements OnInit, OnDestroy {

  visible = false;

  /** Rozwinięta lista kategorii zamiast samych przycisków. */
  details = false;

  /** Kopia robocza - zapisujemy dopiero przyciskiem, więc da się wycofać. */
  analytics = false;
  marketing = false;

  private subscription?: Subscription;

  constructor(private consent: ConsentService) { }

  ngOnInit() {
    this.subscription = this.consent.visibilityChanged.subscribe((visible) => {
      if (visible) {
        const state = this.consent.state;
        this.analytics = state.analytics;
        this.marketing = state.marketing;
        // wracającemu ze stopki pokazujemy od razu to, co przyszedł zmienić
        this.details = this.consent.decided;
      }
      this.visible = visible;
    });

    this.consent.start();
  }

  ngOnDestroy() {
    this.subscription?.unsubscribe();
  }

  /** Zamknięcie krzyżykiem działa tylko przy zmianie zdania - patrz dismiss(). */
  get closable(): boolean {
    return this.consent.decided;
  }

  acceptAll() {
    this.consent.acceptAll();
  }

  rejectAll() {
    this.consent.rejectAll();
  }

  saveChoice() {
    this.consent.save({ analytics: this.analytics, marketing: this.marketing });
  }

  close() {
    this.consent.dismiss();
  }
}
